// Module
var code = "<span v-text=\"value\"></span>\n";
// Exports
export default code;